(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ate-bulk-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ate-bulk-order')) {
    customElements.define('ate-bulk-order', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info');
        this.panel = this.querySelector('.ate-bulk-order__panel');
        this.selection = this.querySelector('.ate-bulk-order__selection');
        this.regularChoice = this.querySelector('input[value="regular"]');
        this.bulkChoice = this.querySelector('input[value="bulk"]');
        this.subtotal = this.querySelector('[data-ate-subtotal]');
        this.savings = this.querySelector('[data-ate-savings]');
        this.total = this.querySelector('[data-ate-total]');
        this.savingsRow = this.querySelector('.ate-bulk-order__savings');
        const variantData = JSON.parse(this.querySelector('[data-ate-variant-prices]').textContent);
        this.variantPrices = new Map(variantData.ids.map((id, index) => [String(id), variantData.prices[index]]));
        this.moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: this.dataset.currency
        });
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.addEventListener('change', (event) => {
          if (event.target === this.bulkChoice) {
            this.panel.hidden = false;
            const input = this.quantityInput();
            if (input && Number(input.value) < 10) this.setQuantity(10);
          } else if (event.target === this.regularChoice) {
            this.setQuantity(1);
            this.panel.hidden = true;
          }
          this.refresh();
        }, { signal });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-quantity]');
          if (button && this.contains(button)) this.setQuantity(Number(button.dataset.quantity));
        }, { signal });
        this.root?.addEventListener('input', (event) => {
          if (event.target.id === this.dataset.quantityId) this.refresh();
        }, { signal });
        this.root?.addEventListener('change', (event) => {
          this.refresh();
          this.queueRefresh();
        }, { signal });
        const priceElement = this.root?.querySelector(`#${CSS.escape(this.dataset.priceId)}`);
        if (priceElement) {
          this.priceObserver = new MutationObserver(() => this.queueRefresh());
          this.priceObserver.observe(priceElement, { childList: true, subtree: true, characterData: true });
        }
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId === this.root?.dataset.section) {
              if (data.variant) this.variantPrices.set(String(data.variant.id), data.variant.price);
              this.refresh();
            }
          });
        }
        this.refresh();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.unsubscribe?.();
        this.priceObserver?.disconnect();
        cancelAnimationFrame(this.refreshFrame);
      }
      quantityInput() {
        return this.root?.querySelector(`#${CSS.escape(this.dataset.quantityId)}`);
      }
      queueRefresh() {
        cancelAnimationFrame(this.refreshFrame);
        this.refreshFrame = requestAnimationFrame(() => this.refresh());
      }
      unitPrice() {
        const variantId = this.root?.querySelector(`#${CSS.escape(this.dataset.formId)} input[name="id"]`)?.value;
        return Number(this.variantPrices.get(variantId) ?? this.dataset.unitPrice);
      }
      money(amount) {
        return `${this.moneyFormatter.format(amount / 100)} ${this.dataset.currency}`;
      }
      setQuantity(requested) {
        const input = this.quantityInput();
        if (!input || input.disabled) return;
        const minimum = Math.max(1, Number(input.min) || 1);
        const step = Math.max(1, Number(input.step) || 1);
        let quantity = minimum + Math.ceil((Math.max(minimum, requested) - minimum) / step) * step;
        if (input.max) quantity = Math.min(quantity, Number(input.max));
        input.value = String(quantity);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        this.refresh();
      }
      refresh() {
        const quantity = Math.max(0, Math.floor(Number(this.quantityInput()?.value) || 0));
        if (quantity >= 10) {
          this.bulkChoice.checked = true;
          this.panel.hidden = false;
        }
        const percent = quantity >= 50 ? 15 : quantity >= 25 ? 10 : quantity >= 10 ? 5 : 0;
        const unitPrice = this.unitPrice();
        const activePercent = this.dataset.discountsReady === 'true' ? percent : 0;
        // Checkout rounds the discounted unit price before multiplying by quantity.
        const discountedUnitPrice = Math.round(unitPrice * (100 - activePercent) / 100);
        const subtotal = unitPrice * quantity;
        const total = discountedUnitPrice * quantity;
        this.subtotal.textContent = this.money(subtotal);
        this.savings.textContent = this.money(total - subtotal);
        this.total.textContent = this.money(total);
        this.savingsRow.hidden = total === subtotal;
        this.selection.textContent = percent
          ? this.dataset.message.replace('[quantity]', String(quantity)).replace('[percent]', String(percent))
          : this.dataset.noDiscount;
        this.querySelectorAll('button[data-quantity]').forEach((button) => {
          const threshold = Number(button.dataset.quantity);
          const active = threshold === 50 ? quantity >= 50 : threshold === 25 ? quantity >= 25 && quantity < 50 : quantity >= 10 && quantity < 25;
          button.setAttribute('aria-pressed', String(active));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
